import { trackAbTestEvent } from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';

export const trackRerankEngagementScoreTest = ({ isSearch, hasCategories, pageContext }) => {
    if (isSearch && hasCategories) {
        const trackingData = getAbTestTrackingData(document.cookie, 'RERANK_ENGAGEMENT_SCORE_TEST');
        trackAbTestEvent(trackingData, pageContext);
    }
};
